const INCLUDE_FOR_MARKETS = ['wa']

const addMarketParamToSearch = (
  search: string,
  marketCode: string,
  includeForMarkets: string[] = INCLUDE_FOR_MARKETS
) => {
  if (includeForMarkets.includes(marketCode?.toLowerCase()) !== true) {
    return search
  }

  const searchIsEmpty = !search || search === ''

  const separator = searchIsEmpty ? '?' : '&'

  return `${search}${separator}market=${marketCode}`
}

export default addMarketParamToSearch
